import * as React from 'react';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';
import Cached from 'material-ui/svg-icons/action/cached';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';

import { withClassname } from '@components/hoc/withClassname';

import { EmployeesForm } from '@modules/employees/EmployeesForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { ActionBar } from '@modules/employees/EmployeesGridButtons';
import { hasAnyPermission } from '@utils/utils';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const employeesUrl = '/metropolis/api/hr/employees';
export const employeesDtoUrl = `${employeesUrl}/dto`;
export const employeesLabel = 'Zaměstnanci';
export const employeesPath = '/employees';
export const employeesGridName = 'module-employees';

const rowStyleFn = item => {
  if (item && item.active === false) {
    return { backgroundColor: '#ffd4d4' };
  }
  return null;
};

export const EmployeesGrid = compose<any, any>(
  withRouter,
  setDisplayName('EmployeesGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: employeesLabel }]),
  withColumns(Agenda.EMPLOYEES),
  withProps(({ columns }) => {
    const hasPermission = hasAnyPermission(['ROLE_EMPLOYEE_READ_INACTIVE']);

    return {
      name: employeesGridName,
      url: employeesDtoUrl,
      Form: EmployeesForm,
      dialog: false,
      gridProps: {
        deleteFiltersTooltip: 'Reset filtrů',
        deleteFiltersIcon: <Cached />,
        columns,
        ActionBar: ActionBar,
        rowStyleFn,
        filterRow: true,
        showCheckboxes: true,
        showDeactivated: hasPermission,
        deleting: true,
        filtering: false,
        locale: 'cz',
        adding: true,
        pageSize: 50,
        version: 13,
        sort: 'created'
      }
    };
  }),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesGrid.tsx